import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateGiftCardGroupMutation = createMutationHook(
  GiftCardsApiClient.updateGiftCardGroup,
  {
    mutationKey: ['updateGiftCardGroup'],
  },
)
